import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, ModalClose } from '@mui/joy';
import { DetailTitle, InfoHeader, Button, useDrawer } from 'src/mtska-frontend-app-component';
import AudienceSegmentCreator from '../wizards/AudienceSegmentCreator';
import { Alert } from '@mui/material';
import { useDataProvider } from 'src/mtska-frontend-data-provider';

const dataProviderName = 'audiences/audiencesegment';
const model = 'audiences/audienceSegment';

const Create = (params) => {
	const { t } = useTranslation();
	const [actionInvoked, setActionInvoked] = useState(0);
	const [errorMessage, setErrorMessage] = useState(null);
	const [forwardDisabled, setForwardDisabled] = useState(false);
	const [backDisabled, setBackDisabled] = useState(true);
	const [actionLabel, setActionLabel] = useState(params.wizardAction === 'actionUpdate' ? t('Save') : t('Next'));
	const [isCompleted, setIsCompleted] = useState(false);

	const { close } = useDrawer();
	const { doAction, errorMessage: dpErrorMessage, saving } = useDataProvider(dataProviderName, params.multipart);

	const handleSave = (data) => {
		const payload = { ...data };
		const action = params.wizardAction === 'actionUpdate' && params.id ? 'actionUpdate' : 'create';
		if (action === 'actionUpdate') payload.id = params.id;

		return doAction({
			action: action,
			model: model || dataProviderName,
			data: payload
		}).then(result => result)
		  .catch(error => {
			  const saveError = error.message || t('An error occurred while saving.');
			  setErrorMessage(saveError);
			  throw error;
		  });
	};

	const handleFinish = () => setIsCompleted(true);

	return (
		<>
			{params.isDrawer && (
				<Box className="drawer-section-header">
					<ModalClose onClick={() => close()} />
					<DetailTitle
						title={params.wizardAction === 'actionUpdate' ? t('Edit audience segment') : t('Create a new segment')}
						icon="faFile"
					/>
					<Box display="flex" flexDirection="row" justifyContent="end" gap={1} flexGrow={1}>
						{!isCompleted && (
							<>
								<Button label={t('Back')} onClick={() => setActionInvoked(-1)} disabled={backDisabled || saving} />
								<Button
									label={actionLabel}
									onClick={() => setActionInvoked(1)}
									disabled={forwardDisabled || saving}
									loading={saving}
								/>
							</>
						)}
						{isCompleted && <Button label={t('Close')} onClick={() => close()} />}
					</Box>
				</Box>
			)}

			{params.isDrawer && <Box className="breadcrumb" sx={{ height: 24, bgcolor: 'transparent' }} />}

			{(errorMessage || dpErrorMessage) && <Alert severity="error">{errorMessage || dpErrorMessage}</Alert>}

			<Box className="drawer-section-content">
				<InfoHeader
					view="wizard"
					title={params.wizardAction === 'actionUpdate' ? t('Edit audience segment') : t('Create audience segment')}
					subtitle={params.wizardAction === 'actionUpdate' ? t('Edit description of segment') : t('Description new segment creation')}
				/>
				<AudienceSegmentCreator
					{...params}
					onSave={handleSave}
					onFinish={handleFinish}
					externalSetForwardDisabled={setForwardDisabled}
					externalSetBackDisabled={setBackDisabled}
					externalSetActionInvoked={setActionInvoked}
					externalSetActionLabel={setActionLabel}
					externalSetErrorMessage={setErrorMessage}
					actionInvoked={actionInvoked}
					isCompleted={isCompleted}
				/>
			</Box>
		</>
	);
};

export default Create;